<!--心理健康-视频-->
<template>
    <div class="mh-home">
        <div class="mh-panel">
            <div class="mh-main">
                <div class="mh-search">
                    <!--分类Tab：政策/视频（切换到政策由父级处理）-->
                    <div class="mh-cat-tabs">
                        <div class="mh-cat-tab mh-cat-tab-active">视频</div>
                        <div class="mh-cat-tab" @click="$emit('change-tab', 'policy')">政策</div>
                        
                    </div>
                    <div class="mh-search-right">
                        <el-input v-model="videoTitle" placeholder="请输入视频名称" clearable
                                  class="mh-search-input" />
                    </div>
                </div>
                <!--每个大模块：标题后跟其子分类Tab，下方平铺归属视频（本地筛选）-->
                <div class="mh-module-container" v-loading="loading">
                    <el-empty v-if="!loading && moduleList.length === 0" description="暂无数据" />
                    <div class="mh-module" v-for="(mod, modIndex) in moduleList" :key="mod.catalogId">
                        <div class="mh-module-head">
                            <div class="mh-module-title" @click="handleTab(mod.catalogId, '')">{{ modIndex + 1 }}、{{ mod.catalogName }}</div>
                            <!--子分类Tab换行展示：开头为全部，带边框，选中加底色-->
                            <div class="mh-module-tabs" v-if="mod.children.length > 0">
                                <div :class="['mh-module-tab', mod.activeChild === '' ? 'mh-module-tab-active' : '']"
                                     @click="handleTab(mod.catalogId, '')">全部</div>
                                <div v-for="child in mod.children" :key="child.catalogId"
                                     :class="['mh-module-tab', mod.activeChild === child.catalogId ? 'mh-module-tab-active' : '']"
                                     @click="handleTab(mod.catalogId, child.catalogId)">{{ child.catalogName }}</div>
                            </div>
                        </div>
                        <div class="mh-card-row" v-if="mod.videos.length > 0">
                            <div v-for="(item, index) in mod.videos" :key="index" class="mh-card"
                                 @click="handlePlay(item)">
                                <img v-if="item.videoCover" class="mh-card-cover"
                                     :src="item.videoCover" />
                                <video v-else class="mh-card-cover"
                                       :src="item.videoUrl + '#t=0.1'"
                                       preload="metadata"></video>
                                <div class="mh-card-name" :title="item.videoTitle">{{ item.videoTitle }}</div>
                                <div class="mh-card-speaker" :title="item.videoSpeaker">
                                    {{ item.videoSpeaker }}<span v-if="item.videoSpeakerOrg">（{{ item.videoSpeakerOrg }}）</span>
                                </div>
                            </div>
                        </div>
                        <data-empty v-else title="暂无相关视频"/>
                    </div>
                </div>
            </div>
        </div>

        <!--视频播放-->
        <el-dialog v-model="isShowPlayDialog" width="76%" top="50px" @close="playUrl = ''">
            <video v-if="playUrl" :src="playUrl" controls autoplay
                   style="width: 100%;max-height:calc(100vh - 250px)"></video>
        </el-dialog>
    </div>
</template>

<script>
import dataEmpty from "@/components/dataEmpty.vue";
import {treeVideoCatalog} from "@/api/admin/videoCatalog";
import {listVideo} from "@/api/admin/video";

export default {
    name: 'mentalHealthVideo',
    components: {dataEmpty},
    data() {
        return {
            loading: false,
            catalogList: [],
            videoTitle: '',
            /*各大模块当前选中的子分类Tab：key为一级目录id，值为子目录id（空为全部）*/
            activeTabs: {},
            dataList: [],
            isShowPlayDialog: false,
            playUrl: '',
        }
    },
    computed: {
        /*名称本地筛选后的视频*/
        filteredList() {
            if (!this.videoTitle) return this.dataList;
            return this.dataList.filter(item => (item.videoTitle || '').includes(this.videoTitle));
        },
        /*大模块及其对应视频：模块下视频不被子分类隔开，含全部下级目录视频；选中子分类Tab时本地过滤*/
        moduleList() {
            return this.catalogList.map(parent => {
                const ids = this.collectCatalogIds(parent);
                const all = this.filteredList.filter(v => ids.includes(v.catalogId));
                const activeChild = this.activeTabs[parent.catalogId] || '';
                let videos = all;
                if (activeChild) {
                    const child = (parent.children || []).find(c => c.catalogId === activeChild);
                    if (child) {
                        const childIds = this.collectCatalogIds(child);
                        videos = all.filter(v => childIds.includes(v.catalogId));
                    }
                }
                return {
                    catalogId: parent.catalogId,
                    catalogName: parent.catalogName,
                    children: parent.children || [],
                    activeChild,
                    videos,
                };
            });
        },
    },
    mounted() {
        this.queryTreeCatalog();
        this.queryVideoList();
    },
    methods: {
        // 查询目录树
        queryTreeCatalog() {
            treeVideoCatalog({catalogProfile: '2'}).then(res => {
                if (res.data.code === 1) {
                    this.catalogList = res.data.data;
                } else {
                    this.$message.error("请求出错")
                }
            })
        },
        // 查询全部视频，本地按模块分组筛选
        queryVideoList() {
            this.loading = true;
            this.dataList = [];
            listVideo({videoType: '2'}).then(res => {
                this.loading = false;
                if (res.data.code === 1) {
                    this.dataList = res.data.data || [];
                } else {
                    this.$message.error("请求出错")
                }
            })
        },
        // 收集目录及其全部下级目录id
        collectCatalogIds(catalog) {
            let ids = [catalog.catalogId];
            (catalog.children || []).forEach(child => {
                ids = ids.concat(this.collectCatalogIds(child));
            });
            return ids;
        },
        // 子分类Tab切换：本地过滤该大模块下的视频
        handleTab(catalogId, childId) {
            this.activeTabs = {...this.activeTabs, [catalogId]: childId};
        },
        // 播放视频
        handlePlay(item) {
            this.playUrl = item.videoUrl;
            this.isShowPlayDialog = true;
        },
    }
}
</script>

<style lang="scss" scoped>
.mh-home {
    width: 100%;
}

.mh-panel {
    display: flex;
    flex-direction: column;
    background: #ffffff;
    border-radius: 24px;
    padding: 22px 26px;
    box-sizing: border-box;
    height: calc(100vh - 174px);
    min-height: 0;
}

/*视频列表*/
.mh-main {
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
    min-height: 0;
}

.mh-search {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 14px;

    /*分类Tab：政策/视频，带边框，选中加底色*/
    .mh-cat-tabs {
        display: flex;
        gap: 10px;
    }

    .mh-cat-tab {
        font-size: 15px;
        color: #17365d;
        cursor: pointer;
        padding: 4px 22px;
        border: 1px solid #b9cfe8;
        border-radius: 17px;
        white-space: nowrap;
        transition: all .15s ease;

        &:hover {
            border-color: #0d55a4;
            color: #0d55a4;
        }
    }

    .mh-cat-tab-active {
        background: #0d55a4;
        border-color: #0d55a4;
        color: #ffffff;

        &:hover {
            color: #ffffff;
        }
    }

    .mh-search-right {
        display: flex;
        align-items: center;
        gap: 12px;

        .mh-search-input {
            width: 260px;
        }
    }
}

/*模块区*/
.mh-module-container {
    flex: 1;
    min-height: 0;
    overflow: auto;

    /*无数据时暂无数据提示居中*/
    :deep(.el-empty) {
        margin-top: 120px;
    }
}

.mh-module {
    margin-bottom: 10px;
}

/*大模块头部：标题独占一行（无下边框横线），子分类Tab换行展示*/
.mh-module-head {
    margin-bottom: 14px;
}

.mh-module-title {
    font-size: 16px;
    font-weight: bold;
    color: #0d55a4;
    cursor: pointer;
    margin-bottom: 10px;
}

.mh-module-tabs {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
}

/*子分类Tab：带边框，选中加底色*/
.mh-module-tab {
    font-size: 13px;
    color: #17365d;
    cursor: pointer;
    padding: 2px 14px;
    border: 1px solid #b9cfe8;
    border-radius: 14px;
    white-space: nowrap;
    transition: all .15s ease;

    &:hover {
        border-color: #0d55a4;
        color: #0d55a4;
    }
}

.mh-module-tab-active {
    background: #0d55a4;
    border-color: #0d55a4;
    color: #ffffff;

    &:hover {
        color: #ffffff;
    }
}

.mh-card-row {
    display: flex;
    flex-wrap: wrap;
}

/*视频卡片*/
.mh-card {
    width: 200px;
    margin: 0 16px 16px 0;
    background: #ffffff;
    border: 1px solid #e4eefb;
    border-radius: 16px;
    overflow: hidden;
    box-sizing: border-box;
    cursor: pointer;
    transition: transform .2s ease;

    &:hover {
        transform: translateY(-4px);
    }
}

.mh-card-cover {
    width: 100%;
    height: 150px;
    object-fit: cover;
    display: block;
    background-color: #000;
}

.mh-card-name {
    padding: 8px 12px 0 12px;
    font-size: 14px;
    color: #17365d;
    box-sizing: border-box;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.mh-card-speaker {
    padding: 4px 12px 8px 12px;
    font-size: 12px;
    color: #909399;
    box-sizing: border-box;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
</style>
